import { Icons } from "assets/icons";
import FilterBar from "components/common/FilterBar";
import NoDataFound from "components/common/NoDataFound";
import Paginations from "components/common/Paginations";
import { StatusBadge } from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import { usePermission } from "hooks/usePermission";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatUTCDate } from "utils/utils";

const STATIC_AUDIT_LOGS = [
  {
    _id: "audit_001",
    action: "Member Created",
    module: "Membership",
    performedBy: "Admin — Ali Hassan",
    targetEntity: "James Harrington (Gold Plan)",
    ipAddress: "192.168.1.10",
    timestamp: "2025-03-25T10:05:00Z",
    status: 1,
  },
  {
    _id: "audit_002",
    action: "Plan Upgraded",
    module: "Membership",
    performedBy: "Admin — Ali Hassan",
    targetEntity: "Sarah Mitchell: Silver → Gold",
    ipAddress: "192.168.1.10",
    timestamp: "2025-03-26T14:22:00Z",
    status: 1,
  },
  {
    _id: "audit_003",
    action: "Vehicle Make Deleted",
    module: "Vehicles",
    performedBy: "SuperAdmin — System",
    targetEntity: "Make: Oldsmobile",
    ipAddress: "10.0.0.1",
    timestamp: "2025-03-27T09:00:00Z",
    status: 0,
  },
  {
    _id: "audit_004",
    action: "ANPR Config Updated",
    module: "Settings",
    performedBy: "Admin — Priya Nair",
    targetEntity: "Camera Zone B — sensitivity adjusted",
    ipAddress: "192.168.1.22",
    timestamp: "2025-03-28T16:45:30Z",
    status: 1,
  },
  {
    _id: "audit_005",
    action: "Member Suspended",
    module: "Membership",
    performedBy: "Admin — Ali Hassan",
    targetEntity: "Robert Chen (Platinum Plan)",
    ipAddress: "192.168.1.10",
    timestamp: "2025-03-29T08:10:00Z",
    status: 0,
  },
];

const AuditLogs = () => {
  const { t } = useTranslation();
  const { noPlans } = Icons || {};
  const { canAction } = usePermission();
  const { canView } = canAction("vehicles");

  const [keyword, setKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const filtered = STATIC_AUDIT_LOGS.filter(
    (log) =>
      log.action.toLowerCase().includes(keyword.toLowerCase()) ||
      log.performedBy.toLowerCase().includes(keyword.toLowerCase()) ||
      log.module.toLowerCase().includes(keyword.toLowerCase())
  );

  const columns = useMemo(
    () => [
      {
        header: t("Action"),
        key: "action",
        render: (value) => <strong>{value}</strong>,
      },
      {
        header: t("Module"),
        key: "module",
      },
      {
        header: t("Performed By"),
        key: "performedBy",
      },
      {
        header: t("Target / Details"),
        key: "targetEntity",
        render: (value) => (
          <div className="text-muted small">{value}</div>
        ),
      },
      {
        header: t("IP Address"),
        key: "ipAddress",
        render: (value) => (
          <div className="ltr_text">{value}</div>
        ),
      },
      {
        header: t("Timestamp"),
        key: "timestamp",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
      {
        header: t("Status"),
        key: "status",
        render: (value) => <StatusBadge status={value} t={t} />,
      },
    ],
    [t]
  );

  if (!canView) return null;

  return (
    <div className="page-content addons_page">
      <h4 className="page_title mb-3">{t("Audit Logs")}</h4>
      <FilterBar
        keyword={keyword}
        setKeyword={setKeyword}
        keywordPlaceholder={t("Search by action, module or admin")}
        filters={[]}
        selectedFilters={{ keyword }}
        onSearch={() => {}}
        onReset={() => setKeyword("")}
        isBtn={false}
        isDateRange={false}
      />

      {filtered.length === 0 && (
        <NoDataFound title={t("No audit logs found")} icon={noPlans} />
      )}

      {filtered.length > 0 && (
        <>
          <DataTable columns={columns} data={filtered} t={t} />
          <Paginations
            currentPage={currentPage}
            totalPages={1}
            totalCount={filtered.length}
            onPageChange={setCurrentPage}
          />
        </>
      )}
    </div>
  );
};

export default AuditLogs;